import axios from 'axios';

const client = axios.create({ baseURL: '', withCredentials: true });

// axios 默认会把数组序列化成 `key[]=v1&key[]=v2`，但 Go 的
// `r.URL.Query()` 只认 `key=v1&key=v2`。`paramsSerializer` 把
// 数组展开成重复 query 参数，让所有 list API 的多值过滤
// (`node_ids`/`region_ids`/`exclude_ids`/...) 都能正确送达后端。
client.defaults.paramsSerializer = {
  indexes: null,
  serialize: (params) => {
    const parts: string[] = [];
    const append = (key: string, value: unknown): void => {
      if (value === null || value === undefined) return;
      if (Array.isArray(value)) {
        for (const v of value) append(key, v);
        return;
      }
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    };
    for (const [k, v] of Object.entries(params)) append(k, v);
    return parts.join('&');
  },
};

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !location.pathname.startsWith('/login')) {
      location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default client;
